<script>
  import { getNavState, getAccessibilityRedesignRenderState } from '../../../../../../js/stores';
  import { blurOnClick } from '../../../../../../js/blurOnClick';
  import { trackLinkClick } from '../../../../../../js/trackLinkClick';

  export let id = undefined;
  export let title = undefined;
  export let url = '#';

  const navStateStore = getNavState();
  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();

  function onMouseOver() {
    // close any sibling categories that may be open.
    $navStateStore = { ...$navStateStore, category: null, subcategory: null };
  }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<a
  {id}
  href={url}
  class="Link"
  class:focus-highlight={!$accessibilityRedesignRenderStore}
  class:link-accessibility-redesign={$accessibilityRedesignRenderStore}
  on:mouseover={onMouseOver}
  use:blurOnClick
  use:trackLinkClick={{ id, title, url }}
>
  <span>{title}</span>
</a>

<style>@charset "UTF-8";
.Link {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  padding: 11px 10px 9px;
}
.Link:focus {
  outline: none;
}

.focus-highlight {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.focus-highlight::-moz-focus-inner {
  border: 0;
}
.focus-highlight:focus {
  outline: none;
}
.focus-highlight::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.focus-highlight:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .focus-highlight:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.focus-highlight > * {
  position: relative;
}

.link-accessibility-redesign {
  background-image: linear-gradient(var(--color-text), var(--color-text));
  background-size: 0% 2px;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) 100%;
  transition: background-size 400ms cubic-bezier(0.4, 0, 0.2, 1);
  padding: 18px 10px;
}
.link-accessibility-redesign:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
@media (hover: hover) {
  .link-accessibility-redesign:hover {
    background-position: calc(0% + 10px) 100%;
    background-size: calc(100% - 20px) 2px;
  }
}</style>
